import { WizardAnswers } from "@zp-services/state.service";
import {
  CreateLeadRequest,
  GroupCode,
  NumberOfEmployees,
} from "src/app/models/lead-collection-mapping";

export function createLeadRequestObject(answers: WizardAnswers): CreateLeadRequest {
  const step1 = answers["step1"] || {};

  const groupCode: GroupCode = step1.is_customer === "yes" ? "Z06" : "Z05";
  const numberOfEmployees = mapNumberOfEmployees(step1.number_of_employees);

  return {
    Company: step1.organisation_name,
    GroupCode: groupCode,
    AantalMdwCat: numberOfEmployees,
    ContactFirstName: step1.firstName,
    ContactLastName: step1.lastName,
    ContactEmail: step1.email,
    ContactMobile: step1.phone_number,
    Answers: answers,
  };
}

function mapNumberOfEmployees(raw: string): NumberOfEmployees {
  const num = parseInt(raw.replace(/\D/g, ""), 10);
  if (num === 1) return "01";
  if (num >= 2 && num <= 9) return "02";
  if (num >= 10 && num <= 49) return "03";
  if (num >= 50 && num <= 199) return "04";
  if (num >= 200 && num <= 1999) return "05";
  if (num >= 2000) return "06";
  return "01"; // fallback
}
